<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0">
      <ChromeSpeechToTextTextarea
        rows="4"
        max-rows="10"
        v-model="evolution.text"
      />

      <div v-if="evolution.evolution_complement">
        <span> Complementos: </span>

        <div class="mb-2">
          <textarea
            class="form-control mr-1"
            rows="5"
            max-rows="10"
            :value="evolution.evolution_complement"
          />
        </div>
      </div>
      <ErrorsMessages :errors="errors" />
    </div>

    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-text-right"
    >
      <div class="sticky-footer-inner">
        <confirmation-dialog
          headerClass="modal-header"
          message-title="Duplicar e Finalizar"
          message-body="Após finalizar, não será possível alterar. Confirmar?"
          open-class="btn-save"
          open-left-icon="fa-check-double mr-2"
          open-text="Salvar e Finalizar"
          @yes="execute({ finish: 1 })"
          :loading="loading"
          :disabled="loading"
        />

        <confirmation-dialog
          headerClass="modal-header"
          message-title="Duplicar e Salvar"
          message-body="Deseja realmente salvar a evolução?"
          open-class="btn-notcertified m-1"
          open-left-icon="fa-check"
          open-text="Salvar"
          @yes="execute({ finish: 0 })"
          :loading="loading"
          :disabled="loading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import ChromeSpeechToTextTextarea from "../Components/ChromeSpeechToTextTextarea";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import ErrorsMessages from "../Components/ErrorsMessages";

import BRyHUB from "../../lib/BRy/hub";

export default {
  name: "Duplicate",

  components: {
    ChromeSpeechToTextTextarea,
    ConfirmationDialog,
    ErrorsMessages,
  },

  props: {
    evolution: Object,
  },

  data() {
    return {
      loading: false,
      errors: [],
    };
  },

  methods: {
    async execute({ finish }) {
      try {
        this.loading = true;

        const { evolution } = this;

        let params = {
          evolution,
          finish,
        };

        const response = await api.post(
          "/rest-home/evolution/duplicate",
          params
        );

        const { error, errors, message, id } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.text = "";
          this.errors = [];

          if (finish == 1) {
            await BRyHUB.authorize({ id, table: "evolution" });
          }
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
